import { constants as Divider } from '../Divider';
import { VARIANT_NO_LIST_STYLE_TYPE, VARIANT_DIVIDERS_BETWEEN, VARIANT_DIVIDERS_BETWEEN_AND_START, VARIANT_DIVIDERS_BETWEEN_AND_END, VARIANT_DIVIDERS_BETWEEN_START_AND_END, ELEMENT_LIST, ELEMENT_DIVIDER, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'List',
    variants: {
        VARIANT_NO_LIST_STYLE_TYPE,
        VARIANT_DIVIDERS_BETWEEN,
        VARIANT_DIVIDERS_BETWEEN_AND_START,
        VARIANT_DIVIDERS_BETWEEN_AND_END,
        VARIANT_DIVIDERS_BETWEEN_START_AND_END,
    },
    elements: {
        ELEMENT_LIST,
        ELEMENT_DIVIDER,
    },
});
export default function getList() {
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_DIVIDER]: {
                components: {
                    [Divider.NAME]: {
                        variant: Divider.variants.VARIANT_DEFAULT,
                    },
                },
            },
        },
    });
}
